var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../../components/third-party/angular-google-maps');
require('../lr-touch');
require('../../components/window-height');

_module.requires.push('ui.bootstrap.module.modal', 'uiGmapgoogle-maps');

_module.service('$mapModal', [
    '$log',
    '$uibModal',

    function $mapModalService($log, $uibModal) {
        /*
        @function openMapModal
        @param {Array} latLng = ex [33.870532,-117.920765]
        */
        return function openMapModal(latLng) {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: ['$scope', function mapeModalCtrl($scope) {
                    $scope.map = {
                        center: {
                            latitude: latLng[0],
                            longitude: latLng[1]
                        },
                        zoom: 14,
                        marker: {
                            coords: {
                                latitude: latLng[0],
                                longitude: latLng[1]
                            }
                        }
                    };
                }],
                backdrop: true,
                windowClass: 'map-modal'
            });

            return modal.result;
        };
    }
]);
